export default "__VITE_ASSET__BnOwwe2q__"